import styled from 'styled-components';

import {
  Checkbox as SemanticCheckbox,
} from 'semantic-ui-react';

export const Checkbox = styled(SemanticCheckbox)`
  &&& {
    margin: 0 0 1em;
  }
`;
